import React, {Component} from 'react';
import './Roller.css';

class RollCaption extends Component {
  getCaption() {
    return this.refs.caption.value;
  }

  render() {
    return (
      <div className="roller_roll_caption">
        <span>Roll Caption</span> <input ref="caption" type="text" />
      </div>
    )
  }
}

export default RollCaption;


// WEBPACK FOOTER //
// ./src/Roller/RollCaption.js